import { AxiosResponse } from "axios";
import PaginateModel from "@/model/paginate";
import Item, { ItemDTO } from "@/model/item";
import api from "./api";

interface RequestInterface {
  data: ItemDTO[];
  paginate: any;
}

interface ItemList {
  list: Item[];
  paginate: any;
}

class ItemApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async getAllItems(query): Promise<ItemList> {
    const response = await this.getHttp().get<RequestInterface>("admin/items", {
      params: query,
    });
    const list: Item[] = [];
    response.data.data.map((ItemDto) => list.push(new Item(ItemDto)));
    const paginate = new PaginateModel(response.data.paginate.Items);
    return {
      list: list,
      paginate: paginate,
    };
  }
  async add(data): Promise<AxiosResponse> {
    return this.getHttp().post<Item>("/admin/items", data);
  }
}
export default new ItemApi();
